import { render, staticRenderFns } from "./TaskDetailTemplate.vue?vue&type=template&id=7eb3f7f2&scoped=true"
import script from "./TaskDetailTemplate.vue?vue&type=script&lang=js"
export * from "./TaskDetailTemplate.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailTemplate.vue?vue&type=style&index=0&id=7eb3f7f2&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb3f7f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eb3f7f2')) {
      api.createRecord('7eb3f7f2', component.options)
    } else {
      api.reload('7eb3f7f2', component.options)
    }
    module.hot.accept("./TaskDetailTemplate.vue?vue&type=template&id=7eb3f7f2&scoped=true", function () {
      api.rerender('7eb3f7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/preScreening/taskDetail/TaskDetailTemplate.vue"
export default component.exports